import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const applyLang = (lng) => {
  const code = lng?.startsWith("en") ? "en" : "de";
  document.documentElement.lang = code;
};

export const LangSync = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    applyLang(i18n.language);
    const onChange = (lng) => applyLang(lng);
    i18n.on("languageChanged", onChange);
    return () => i18n.off("languageChanged", onChange);
  }, [i18n]);

  return null;
};

export default LangSync;
